import { Grid } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BoundTextField } from "lib/@components/binding/bound-components"

export function ClientScheduleFields() {
    const { editMode } = useBoundContext()
    return (
        <>
            <Grid item xs={12}>
                <BoundTextField
                    inputProps={{ readOnly: !editMode }}
                    multiline
                    label="Custom Field"
                    field="clientCustomField"
                    data-cy="client-custom-field"
                />
            </Grid>
            <Grid item xs={12}>
                <BoundTextField
                    inputProps={{ readOnly: !editMode, maxLength: 20 }}
                    label="Reference Tag"
                    field="clientReferenceTag"
                    data-cy="client-reference-tag"
                />
            </Grid>
        </>
    )
}
